import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

import Balloon from "../Others/balloon";
import DotSpinner from "../Spinner/DotSpinner";

const Widget = (props) => {
    let countDisplay = <h3 className={props.className}>{props.number}</h3>;
    if (props.progress)
        countDisplay = <div style={{fontSize: "1.525rem"}}><DotSpinner color={"bg-" + props.colorIcon}/></div>;

    return (
        <div className="card justify-content-center">
            <div className="d-flex justify-content-between">
                <div className="align-self-center w-100">
                    <Link to={props.to} >
                        <Balloon color={props.colorIcon} icon={props.icon} className="mt-5"/>
                    </Link>
                </div>
                <div className="text-right flex-shrink-1">
                    {countDisplay}
                    <p className="mb-0" style={{height:"43px"}}>{props.label}</p>
                </div>
            </div>
        </div>
    );
}

Widget.defaultProps = {
    progress: false
}

Widget.propTypes = {
    label: PropTypes.string,
    number: PropTypes.string,
    to: PropTypes.string,
    icon: PropTypes.object,
    styles: PropTypes.string,
    className: PropTypes.string,
    colorIcon: PropTypes.string,
    progress: PropTypes.bool
};

export default (Widget);